import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }   from '@angular/forms';

import { BbToastComponent } from '../components/shared/bb-toast/bb-toast.component';
import { OverlayService } from '../services/overlay.service';
import { BbOverlayComponent } from '../components/shared/bb-overlay/bb-overlay.component';
import { BbDialogComponent } from '../components/shared/bb-dialog/bb-dialog.component';
import { BbNoticeComponent } from '../components/shared/bb-notice/bb-notice.component';

// hmn, we need to import all modules containing stuff we might want to show in a modal
import { LibraryModule } from './library.module';
import { AnalyticsModule } from './analytics.module';
import { SharedModule } from './shared.module';

// BbModalComponent is also used in other modules so that's imported in the shared module

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		LibraryModule,
		AnalyticsModule,
		SharedModule
	],
	declarations: [
		BbToastComponent,
		BbOverlayComponent,
		BbDialogComponent,
		BbNoticeComponent
	],
	exports: [
		BbToastComponent,
		BbOverlayComponent,
		BbDialogComponent,
		BbNoticeComponent
	],
	providers: [
		OverlayService
	]
})
export class OverlayModule {

}
